import { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ImageListItem from "@mui/material/ImageListItem";
import IconButton from "@mui/material/IconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Stack from "@mui/material/Stack";
import Icon from "@mui/material/Icon";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DownloadIcon from "@mui/icons-material/Download";
import IconList from "../../../../helpers/icons";

export const SortableItem = ({ id, item, handleModalOpen, handleDeleteImage }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <ImageListItem
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            sx={{
                touchAction: "none",
                cursor: isDragging ? "grabbing" : "grab",
            }}
        >
            <ImageItemContent item={item} handleModalOpen={handleModalOpen} handleDeleteImage={handleDeleteImage} />
        </ImageListItem>
    );
};

export const ImageItemContent = ({ item, handleModalOpen, handleDeleteImage, isDragging }) => {
    const [copyToClipboardText, setCopyToClipboardText] = useState("Kopirajte link");

    let imageUrl = false;
    if (item?.src?.includes("image")) {
        imageUrl = item.src;
    } else if (item?.image?.includes("image")) {
        imageUrl = item.image;
    }

    return (
        <Box sx={{ position: "relative" }}>
            {imageUrl || item?.src?.includes("video") ? (
                imageUrl ? (
                    <img
                        key={imageUrl}
                        src={imageUrl}
                        srcSet={imageUrl}
                        alt={item?.name}
                        loading="lazy"
                        style={{
                            height: "10rem",
                            maxWidth: "100%",
                            margin: "auto",
                            objectFit: "contain",
                            display: "flex",
                        }}
                        onClick={(e) =>
                            handleModalOpen(e, imageUrl, item.alt, item.name, item.size, item.type, item.id, item.position, item.path, item.dimensions, item.id_product, item.file_upload_new)
                        }
                    />
                ) : (
                    <video
                        key={item.src}
                        src={item?.src}
                        autoPlay={true}
                        style={{
                            height: "10rem",
                            maxWidth: "9rem",
                            margin: "auto",
                        }}
                        onClick={(e) =>
                            handleModalOpen(e, item.src, item.alt, item.name, item.size, item.type, item.id, item.position, item.path, item.dimensions, item.id_product, item.file_upload_new)
                        }
                    >
                        <source src={item?.src} type="video/mp4" />
                    </video>
                )
            ) : (
                <Box
                    key={item.src}
                    style={{
                        height: "10rem",
                        background: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={(e) => handleModalOpen(e, item)}
                >
                    {item.thumb_image ? <img src={item.thumb_image} width="100%" height="100%" /> : <Icon fontSize="large">{IconList.editDocument}</Icon>}
                </Box>
            )}
            <Stack sx={{ background: "rgba(0, 0 , 0,0.4)", borderRadius: "0 0 0.25rem 0.25rem", position: "absolute", bottom: 0, width: "100%" }}>
                <Typography
                    variant="subtitle2"
                    noWrap
                    style={{ cursor: "pointer", color: "#ffff", fontSize: "0.75rem", padding: "0.3rem 0 0 0.3rem" }}
                    onClick={(e) => handleModalOpen(e, item.src, item.alt, item.name, item.size, item.type, item.id, item.position, item.path, item.dimensions, item.id_product, item.file_upload_new)}
                >
                    Naziv: {item?.name}
                </Typography>

                <Typography
                    variant="subtitle2"
                    noWrap
                    style={{ cursor: "pointer", color: "#ffff", fontSize: "0.625rem", padding: "0 0 0 0.3rem" }}
                    onClick={(e) => handleModalOpen(e, item.src, item.alt, item.name, item.size, item.type, item.id, item.position, item.path, item.dimensions, item.id_product, item.file_upload_new)}
                >
                    Veličina: {Math.round((item?.size / 1024 / 1024) * 1000) / 1000} MB
                </Typography>

                <Box sx={{ display: "flex" }}>
                    <IconButton sx={{ color: "#ffff" }}>
                        <CopyToClipboard
                            text={item?.path}
                            onCopy={() => {
                                setCopyToClipboardText("Link je kopiran");
                                setTimeout(() => {
                                    setCopyToClipboardText("Kopirajte link");
                                }, 3000);
                            }}
                        >
                            <Tooltip title={copyToClipboardText} placement="bottom" arrow>
                                <ContentCopyIcon sx={{ fontSize: "1.35rem" }} />
                            </Tooltip>
                        </CopyToClipboard>
                    </IconButton>
                    <Tooltip title={"Preuzmite sliku"} placement="bottom" arrow>
                        <IconButton
                            sx={{ color: "#ffff" }}
                            onClick={() => {
                                const image = item?.path;
                                window.open(`${image}`, "_blank");
                            }}
                        >
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Obriši sliku" placement="bottom" arrow>
                        <IconButton
                            sx={{ color: "#ffff", marginLeft: "auto" }}
                            aria-label={`delete ${item.name}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleDeleteImage(item.id, item.new);
                            }}
                        >
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Stack>
        </Box>
    );
};
